/* eslint-disable */ import { memoEval, sceneEntityRemoteObjectComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const lynxProfessionalWineCellarW15Components = [
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'default', true).withEntity('LynxProfessionalWineCellarW15').attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/jms.glb',
            objectName: 'REFRIGERATOR_LN15WINE',
            dimensionUnit: 'inch'
        })))
];

//# sourceMappingURL=lynx-professional-wine-cellar-w-15.js.map